module.exports = __webpack_public_path__ + "media/images/icon_news_blue-dbe5a0c5ae2589dfdb180e8bb1fa3606.png";